import {
  type Affordance,
  type DigestItem,
  type DigestModel,
  resolveAffordance,
} from "@reflecto/client-core";

/** Capability-gated affordance for a digest row. `opts.repliable` is the item's stored `repliable` (set by the triage pass). */
export function affordanceFor(item: DigestItem, opts: { repliable: boolean }): Affordance {
  return resolveAffordance(
    { suggestedAction: item.suggestedAction, category: item.category },
    opts
  );
}

/** A digest is "empty" only when classification settled (nothing pending) AND produced no content — used to suppress the card. */
export function isDigestEmpty(model: DigestModel): boolean {
  return model.pending === 0 && model.needsYou.length === 0 && model.quiet.length === 0;
}
